import { Controller } from "@hotwired/stimulus"

// Tiny controller that opens the manage-rules modal and triggers a fresh
// load. Living as its own controller keeps the toolbar button template
// declarative — no inline JS, no global handlers.

export default class extends Controller {
  open(event) {
    event?.preventDefault()
    document.dispatchEvent(new CustomEvent("portfolio-alert-manage:open"))
  }
}
